/* ============================================================================
   HYPESTALK theme engine (Online Store 2.0)
   - Real Shopify AJAX cart (/cart/add.js, /cart/change.js, /cart.js)
   - UI behaviours: sticky header, mobile menu, cart drawer, FAQ, reveal,
     3D tilt, countdown, back-to-top
   - Re-initialises on Shopify Theme Editor events so it works while editing.
   You normally never need to edit this file - content is edited in Customize.
   ============================================================================ */
(function () {
  "use strict";
  var $  = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };

  /* ---------- Money formatting (uses the store's own format) ---------- */
  function formatMoney(cents) {
    var fmt = (window.HS && window.HS.moneyFormat) || "${{amount}}";
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "";
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ","; decimal = decimal || ".";
      var n = (cents / 100).toFixed(precision);
      var parts = n.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : "";
      return dollars + centsPart;
    }
    switch ((fmt.match(placeholder) || [])[1]) {
      case "amount": value = num(2); break;
      case "amount_no_decimals": value = num(0); break;
      case "amount_with_comma_separator": value = num(2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = num(0, ".", ","); break;
      case "amount_with_space_separator": value = num(2, " ", ","); break;
      default: value = num(2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------- Cart drawer ---------- */
  function openCart()  { var d = $("#cartDrawer"), o = $("#overlay"); if (d) d.classList.add("show"); if (o) o.classList.add("show"); document.body.style.overflow = "hidden"; }
  function closeCart() { var d = $("#cartDrawer"), o = $("#overlay"); if (d) d.classList.remove("show"); if (o) o.classList.remove("show"); document.body.style.overflow = ""; }

  function renderCart(cart) {
    var count = cart.item_count;
    $$("[data-cart-count]").forEach(function (el) { el.textContent = count; el.classList.toggle("show", count > 0); });
    var items = $("#cartItems");
    var foot  = $("#cartFoot");
    if (!items) return;
    if (count === 0) {
      items.innerHTML = '<div class="cart-empty"><div class="ic">\u{1F6D2}</div><p>Your cart is empty.</p></div>';
      if (foot) foot.style.display = "none";
      return;
    }
    if (foot) foot.style.display = "block";
    items.innerHTML = cart.items.map(function (it) {
      return '<div class="cart-row">' +
        '<img src="' + (it.image ? it.image.replace(/(\.[^.]*)$/, "_120x$1") : "") + '" alt="" onerror="this.style.opacity=0">' +
        '<div class="ci"><div class="t">' + it.product_title + '</div>' +
        '<div class="c">' + (it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : (it.product_type || "")) + '</div>' +
        '<div class="qty"><button data-dec="' + it.key + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button data-inc="' + it.key + '" aria-label="Increase">+</button></div>' +
        '<div class="pr">' + formatMoney(it.final_line_price) + '</div></div>' +
        '<button class="cart-del" data-del="' + it.key + '">Remove</button></div>';
    }).join("");

    var sub = $("#subtotal"); if (sub) sub.textContent = formatMoney(cart.total_price);
    var tot = $("#cartTotal"); if (tot) tot.textContent = formatMoney(cart.total_price);

    var threshold = (window.HS && window.HS.freeShip) || 0;
    var note = $("#shipNote");
    if (note && threshold > 0) {
      var remain = threshold * 100 - cart.total_price;
      note.innerHTML = remain > 0
        ? "\u{1F69A} Add <b style='color:#fff'>&nbsp;" + formatMoney(remain) + "&nbsp;</b> more for FREE shipping"
        : "✓ You've unlocked FREE shipping!";
    }
    bindCartRowButtons();
  }

  function fetchCart() { return fetch(window.Shopify.routes.root + "cart.js").then(function (r) { return r.json(); }).then(renderCart); }

  function addToCart(id, qty) {
    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); }).then(function (item) {
      return fetchCart().then(function () { toast((item.product_title || "Item") + " added to cart"); openCart(); });
    });
  }

  function changeCart(key, qty) {
    return fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function bindCartRowButtons() {
    $$("#cartItems [data-inc]").forEach(function (b) { b.onclick = function () { changeCart(b.getAttribute("data-inc"), qtyOf(b, 1)); }; });
    $$("#cartItems [data-dec]").forEach(function (b) { b.onclick = function () { changeCart(b.getAttribute("data-dec"), qtyOf(b, -1)); }; });
    $$("#cartItems [data-del]").forEach(function (b) { b.onclick = function () { changeCart(b.getAttribute("data-del"), 0); }; });
  }
  function qtyOf(btn, delta) { var span = btn.parentNode.querySelector("span"); return Math.max(0, parseInt(span.textContent, 10) + delta); }

  /* ---------- Add-to-cart buttons (product cards + product form) ---------- */
  function bindAddButtons(scope) {
    $$("[data-add-to-cart]", scope).forEach(function (btn) {
      if (btn.__bound) return; btn.__bound = true;
      btn.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = btn.getAttribute("data-add-to-cart");
        if (!id) return;
        btn.classList.add("loading");
        addToCart(id, 1).then(function () { btn.classList.remove("loading"); })
          .catch(function () { btn.classList.remove("loading"); toast("Sorry, couldn't add that item"); });
      });
    });
    var form = $("[data-product-form]", scope);
    if (form && !form.__bound) {
      form.__bound = true;
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var id = form.querySelector("[name='id']").value;
        addToCart(id, parseInt((form.querySelector("[name='quantity']") || {}).value || 1, 10));
      });
    }
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $("#toast"); if (!t) return;
    var m = $("#toastMsg"); if (m) m.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2200);
  }

  /* ---------- 3D tilt ---------- */
  function bindTilt(scope) {
    $$(".tilt", scope).forEach(function (el) {
      el.onmousemove = function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = "perspective(900px) rotateY(" + (x * 10) + "deg) rotateX(" + (-y * 10) + "deg) translateY(-4px)";
      };
      el.onmouseleave = function () { el.style.transform = ""; };
    });
  }

  /* ---------- Scroll reveal ---------- */
  var io = ("IntersectionObserver" in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
  }, { threshold: 0.12 }) : null;
  function bindReveal(scope) { $$(".reveal:not(.in)", scope).forEach(function (el) { io ? io.observe(el) : el.classList.add("in"); }); }

  /* ---------- FAQ accordion ---------- */
  function bindFaq(scope) {
    $$(".faq-item", scope).forEach(function (item) {
      var q = $(".faq-q", item); if (!q || q.__bound) return; q.__bound = true;
      q.addEventListener("click", function () {
        var open = item.classList.contains("open");
        $$(".faq-item", item.closest(".faq-wrap") || scope).forEach(function (i) { i.classList.remove("open"); var a = $(".faq-a", i); if (a) a.style.maxHeight = null; });
        if (!open) { item.classList.add("open"); var a = $(".faq-a", item); if (a) a.style.maxHeight = a.scrollHeight + "px"; }
      });
    });
  }

  /* ---------- Countdown ---------- */
  function bindCountdown(scope) {
    $$("[data-countdown]", scope).forEach(function (cd) {
      if (cd.__bound) return; cd.__bound = true;
      var days = parseInt(cd.getAttribute("data-countdown"), 10) || 5;
      var key = "hs_sale_end_" + (cd.getAttribute("data-id") || "x");
      var end = parseInt(localStorage.getItem(key), 10);
      if (!end || isNaN(end)) { end = Date.now() + days * 864e5; localStorage.setItem(key, end); }
      var pad = function (n) { return ("0" + n).slice(-2); };
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var d = Math.floor(diff / 864e5); diff -= d * 864e5;
        var h = Math.floor(diff / 36e5); diff -= h * 36e5;
        var m = Math.floor(diff / 6e4); diff -= m * 6e4;
        var s = Math.floor(diff / 1e3);
        var set = function (k, v) { var el = cd.querySelector('[data-cd="' + k + '"]'); if (el) el.textContent = pad(v); };
        set("d", d); set("h", h); set("m", m); set("s", s);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- Count-up stats ---------- */
  function bindCountUp(scope) {
    $$("[data-count]", scope).forEach(function (el) {
      if (el.__counted) return; el.__counted = true;
      var target = parseFloat(el.getAttribute("data-count")), dec = parseInt(el.getAttribute("data-decimal"), 10) || 0;
      var cur = 0, step = target / 60;
      (function tick() {
        cur += step;
        if (cur < target) { el.textContent = dec ? cur.toFixed(dec) : Math.floor(cur).toLocaleString(); requestAnimationFrame(tick); }
        else { el.textContent = (dec ? target.toFixed(dec) : target.toLocaleString()) + (target >= 1000 ? "+" : ""); }
      })();
    });
  }

  /* ---------- Per-section init (re-runs in Theme Editor) ---------- */
  function initSection(scope) { bindReveal(scope); bindTilt(scope); bindFaq(scope); bindCountdown(scope); bindAddButtons(scope); bindCountUp(scope); }

  /* ---------- Global, bind-once ---------- */
  function initGlobal() {
    var header = $("#header");
    var toTop = $("#toTop");
    window.addEventListener("scroll", function () {
      if (header) header.classList.toggle("scrolled", window.scrollY > 20);
      if (toTop) toTop.classList.toggle("show", window.scrollY > 600);
    });
    var oc = $("#openCart"); if (oc) oc.addEventListener("click", function (e) { e.preventDefault(); openCart(); });
    var cc = $("#closeCart"); if (cc) cc.addEventListener("click", closeCart);
    var ov = $("#overlay"); if (ov) ov.addEventListener("click", closeCart);
    var om = $("#openMenu"); if (om) om.addEventListener("click", function () { var mm = $("#mobileMenu"); if (mm) mm.classList.add("show"); });
    var cm = $("#closeMenu"); if (cm) cm.addEventListener("click", function () { var mm = $("#mobileMenu"); if (mm) mm.classList.remove("show"); });
    $$("#mobileMenu a").forEach(function (a) { a.addEventListener("click", function () { var mm = $("#mobileMenu"); if (mm) mm.classList.remove("show"); }); });
    if (toTop) toTop.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: "smooth" }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeCart(); var mm = $("#mobileMenu"); if (mm) mm.classList.remove("show"); } });
    if (window.Shopify && window.Shopify.routes) fetchCart();
  }

  document.addEventListener("DOMContentLoaded", function () { initGlobal(); initSection(document); });
  document.addEventListener("shopify:section:load", function (e) { initSection(e.target); });
  document.addEventListener("shopify:section:select", function (e) { initSection(e.target); });
  window.HSCart = { open: openCart, close: closeCart, add: addToCart, refresh: fetchCart };
})();
